import { Component, OnInit, OnDestroy, ViewChild, QueryList, ViewChildren } from '@angular/core';
import { ActivityService } from 'app/services/activity.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import { CommonFunctionService } from 'app/services/common-function.service';
import { EditService } from 'app/services/edit.service';
import { MainDataService } from 'app/services/main-data.service';
import { QaResolverFeed, ResolutionCenterService } from 'app/services/resolution-center.service';
import { ResolutionQcService } from 'app/services/resolution-qc.service';
import { Subscription } from 'rxjs';
import { ResolutionAOEComponent } from '../resolution-aoe/resolution-aoe.component';
import { ResolutionASQComponent } from '../resolution-asq/resolution-asq.component';
import { ResolutionCADComponent } from '../resolution-cad/resolution-cad.component';
import { ResolutionDAVComponent } from '../resolution-dav/resolution-dav.component';
import { ResolutionRAOComponent } from '../resolution-rao/resolution-rao.component';

@Component({
  selector: 'app-resolution-inspector',
  templateUrl: './resolution-inspector.component.html',
  styleUrls: ['./resolution-inspector.component.css']
})
export class ResolutionInspectorComponent implements OnInit, OnDestroy {

	@ViewChild('aoeTemplate', { static: false }) aoeTemplate: ResolutionAOEComponent;
	@ViewChild('asqTemplate', { static: false }) asqTemplate: ResolutionASQComponent;
	@ViewChild('davTemplate', { static: false }) davTemplate: ResolutionDAVComponent;
	@ViewChildren('raoTemplate') raoTemplates: QueryList<ResolutionRAOComponent>;
	@ViewChild('cadTemplate', { static: false }) cadTemplate: ResolutionCADComponent;

	private qaResolverFeeds: QaResolverFeed[] = [];
	recordRaw: any;

	aoeFeed: QaResolverFeed;
	asqFeed: QaResolverFeed;
	davFeed: QaResolverFeed;
	raoFeeds: QaResolverFeed[];
	// raoFeed: QaResolverFeed;
	cadFeed: QaResolverFeed;

	hasDataChange: boolean;

	private resoFeedSub: Subscription;

	constructor(
		private activityService: ActivityService,
		private attrIndexService: AttrIndexService,
		private commonService: CommonFunctionService,
		private editService: EditService,
		private mainDataService: MainDataService,
		private resoCenterService: ResolutionCenterService,
		private resoQcService: ResolutionQcService
	) { }

	async discard() {
		const confirmDiscard = await this.editService.warnOnDiscard();
		if (!confirmDiscard) {
			return;
		}
		// restore geom
		const geomChangedIds = [];
		const recordsIndex = this.resoCenterService.getRecordsIndex();
		Object.keys(recordsIndex).forEach(id => {
			if (recordsIndex[id].changedCols.indexOf(this.attrIndexService.geomColManual) > -1) {
				geomChangedIds.push(id);
			}
		});
		if (geomChangedIds.length > 0) {
			this.activityService.resetFeatures.next({
				ids: geomChangedIds
			});
		}
		// restore attrs // TODO
		Object.keys(recordsIndex).forEach(id => {
			const rec = recordsIndex[id];
			if (rec.changedCols.length) {
				rec.changedCols.splice(0, rec.geomLength);
				Object.keys(rec.props).forEach(k => rec.props[k] = rec.originalProps[k])
				// rec.changedCols = [];
				// rec.props = JSON.parse(JSON.stringify(rec.originalProps));
			}
		})
		let resoFeed = this.resoCenterService.resoFeedBS.getValue();
		if (!resoFeed || !resoFeed.record || !resoFeed.feeds) {
			this.clearAllFeeds();
			return;
		}
		// const original = resoFeed.record[this.attrIndexService.originalDataKey];
		// const newDataRecord = JSON.parse(JSON.stringify(original));
		// newDataRecord[this.attrIndexService.originalDataKey] = original;
		this.mainDataService.clearDataChangeInIndex(resoFeed.recordId);
		const newDataRecord = this.mainDataService.getDataAttrs(resoFeed.recordId);
		this.resoCenterService.resoFeedBS.next({
			record: newDataRecord,
			feeds: resoFeed.feeds,
			recordId: resoFeed.recordId
		});
		this.updateCode();
	}
	async commit() {
		const spinnerId = this.commonService.getRandomId();
		this.commonService.setLoadingSpinner(true, spinnerId);
		try {
			await this.resoCenterService.commit();
			this.resoCenterService.setRecordsIndex({});
			this.hasDataChange = false;
		} catch (err) {
			console.log(err);
		}
		this.commonService.setLoadingSpinner(false, spinnerId);
	}

	checkCommitable() {
		this.hasDataChange = this.hasChanged();
		return this.hasDataChange;
	}

	onEdit() {
		this.updateCode();
	}
	updateCode() {
		if (this.aoeTemplate) {
			this.aoeTemplate.rules.forEach(rule => {
				switch (rule.code) {
					case 'ADN':
						const recordInfo = this.resoCenterService.getRecordInfo(this.aoeTemplate.centerline.id);
						const geomLength = recordInfo.geomLength;
						rule.isFixed = !this.resoQcService.checkADN(this.aoeTemplate.centerline.props, geomLength);
						break;
					case 'AOE':
						rule.isFixed = !this.resoQcService.checkAOE(this.aoeTemplate.centerline.props);
						break;
					case 'ARG':
						rule.isFixed = !this.resoQcService.checkARG(this.aoeTemplate.centerline.props);
						break;
					case 'ADR':
						rule.isFixed = !this.resoQcService.checkADR(this.aoeTemplate.centerline.props);
						break;
					case 'RDR':
						rule.isFixed = this.aoeTemplate.isFlipRoadGeom;
						break;
				}
			});
		}
		if (this.asqTemplate) {
			this.asqTemplate.rules.forEach(rule => {
				switch (rule.code) {
					case 'ASQ':
						const recordPropsList = this.asqTemplate.addrList.map(i => i.props);
						rule.isFixed = !this.resoQcService.checkASQ(recordPropsList);
						break;
				}
			})
		}
		if (this.davTemplate) {
			this.davTemplate.rules.forEach(rule => {
				switch (rule.code) {
					case 'DAV':
					case 'DAVL':
						const recordPropsList = this.davTemplate.addrList.map(i => i.props);
						const cols = this.davTemplate.cols.map(c => c.prop);
						rule.isFixed = !this.resoQcService.checkDAV(recordPropsList, cols);
						break;
				}
			})
		}
		if (this.raoTemplates) {
			this.raoTemplates.toArray().forEach(raoComponent => {
				raoComponent.rules.forEach(rule => {
					switch (rule.code) {
						case 'RAO':
						case 'RAOL':
							raoComponent.updateRAO();
							// rule.isFixed = !this.resoQcService.checkRAO(this.raoTemplate.centerlineList[0].props, this.raoTemplate.centerlineList[1].props);
							rule.isFixed = !raoComponent.centerlineList.find(i => i.isFromLeftError || i.isFromRightError || i.isToLeftError || i.isToRightError);
							break;
					}
				})
			});
		}
	}

	private hasChanged() {
		const recordsIndex = this.resoCenterService.getRecordsIndex();
		const changed = Object.keys(recordsIndex).find(id => !!this.resoCenterService.getRecordInfo(id).changedCols.length);
		if(changed) {
			return true;
		}
		return false;
	}
	private clearAllFeeds() {
		this.aoeFeed = null;
		this.asqFeed = null;
		this.davFeed = null;
		this.raoFeeds = null;
		// this.raoFeed = null;
	}

	private async onFeedChange() {
		// Clear stored records
		this.resoCenterService.setRecordsIndex({});
		// Get details for all the records that are involved
		const idsByCate = {}
		this.qaResolverFeeds.forEach(i => {
			Object.keys(i.feed).forEach(cateCode => {
				if (!idsByCate[cateCode]) {
					idsByCate[cateCode] = [];
				}
				if (idsByCate[cateCode].indexOf(i.feed[cateCode].id) === -1) {
					idsByCate[cateCode].push(i.feed[cateCode].id);
				}
				if (i.feed[cateCode].list) {
					i.feed[cateCode].list.forEach(id => {
						if (idsByCate[cateCode].indexOf(id) === -1) {
							idsByCate[cateCode].push(id);
						}
					})
				}
			});
		});
		for (let cateCode of Object.keys(idsByCate)) {
			if (idsByCate[cateCode].length) {
				await this.resoCenterService.getRecordsDetails(cateCode, idsByCate[cateCode]);
			}
		}

		this.clearAllFeeds();
		this.qaResolverFeeds.forEach(i => {
			if (i.rules.find(cd => ['AOE', 'ADN', 'ARG', 'ADR', 'RDR'].indexOf(cd) > -1)) {
				this.aoeFeed = i;
			} else if (i.rules.find(cd => ['ASQ'].indexOf(cd) > -1)) {
				this.asqFeed = i;
			} else if (i.rules.find(cd => ['DAV', 'DAVL'].indexOf(cd) > -1)) {
				this.davFeed = i;
			} else if (i.rules.find(cd => ['RAO', 'RAOL'].indexOf(cd) > -1)) {
				if (!this.raoFeeds) {
					this.raoFeeds = [];
				}
				this.raoFeeds.push(i);
				// this.raoFeed = i;
			} else if (i.rules.find(cd => ['CAD'].indexOf(cd) > -1)) {
				this.cadFeed = i;
			}


		});
	}

	ngOnInit() {
		this.resoFeedSub = this.resoCenterService.resoFeedBS.subscribe(async data => {
			if (!data || !data.record || !data.feeds) {
				this.clearAllFeeds();
				return;
			}
			this.recordRaw = data.record;
			this.qaResolverFeeds = data.feeds;
			await this.onFeedChange();
		})
	}
	ngOnDestroy(): void {
		this.resoFeedSub.unsubscribe();
	}
}
